import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";
import { blogCategoryCRUDApi } from "../constants/apis";

// Get all blog categories
export const getBlogCategories = async (query = "") => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.get(
            `${blogCategoryCRUDApi}${query}`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error fetching blog categories:", error);
        throw error;
    }
};

// Get single blog category
export const getBlogCategory = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.get(
            `${blogCategoryCRUDApi}${id}/`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error fetching blog category:", error);
        throw error;
    }
};

// Create blog category
export const createBlogCategory = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.post(
            blogCategoryCRUDApi,
            data,
            config
        );
        return response;
    } catch (error) {
        console.error("Error creating blog category:", error);
        throw error;
    }
};

// Update blog category
export const updateBlogCategory = async ({ id, data }) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.put(
            `${blogCategoryCRUDApi}${id}/`,
            data,
            config
        );
        return response;
    } catch (error) {
        console.error("Error updating blog category:", error);
        throw error;
    }
};

// Patch blog category
export const patchBlogCategory = async ({ id, data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.patch(
            `${blogCategoryCRUDApi}${id}/`,
            data,
            config
        );
        return response;
    } catch (error) {
        console.error("Error patching blog category:", error);
        throw error;
    }
};

// Delete blog category
export const deleteBlogCategory = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.delete(
            `${blogCategoryCRUDApi}${id}/`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error deleting blog category:", error);
        throw error;
    }
};
